/**
 * @description: 数组转化为树形数据  （需要按顺序的数组方可使用）
 * @param {*} arr
 * @param {*} options idField id字段名  parentIdField 父节点字段名   childrenField 儿子字段   firstId 第一级id labelArrField 新生成的labelArr 表示层级关系  idArrField 同理
 * @author: syx
 */
export const ListToTree = (data, config, parentObj) => {
  const defaultOptions = {
    idField: "id", //唯一标识字段名
    parentIdField: "parentId", //父节点唯一标识字段名
    childrenField: "children", //子节点标识字段名
    firstId: "0", // 根节点值
    labelField: "label", //label字段名
    labelArrField: "labelArr", //给对象新增的中文数组字段名
    idArrField: "idArr", //给对象新增的id数组字段名
    levelField: "level", //给对象新增的层级字段名
    level: 0, // 给根目录配置的层级
    leafField: "leaf" //叶子节点标识字段名
  }
  Object.assign(defaultOptions, config)

  if (!parentObj) {
    parentObj = {
      [defaultOptions.idField]: defaultOptions.firstId,
      [defaultOptions.levelField]: defaultOptions.level,
      [defaultOptions.labelArrField]: [],
      [defaultOptions.idArrField]: []
    }
  }

  var tree = []
  var temp
  // 遍历数组
  for (var i = 0; i < data.length; i++) {
    // 如果这个元素的 父id 是要找的
    if (data[i][defaultOptions.parentIdField] === parentObj[defaultOptions.idField]) {
      var obj = data[i]
      // 给元素添加层级标志
      obj[defaultOptions.levelField] = parentObj[defaultOptions.levelField] + 1
      // 给元素添加 字段数组
      obj[defaultOptions.labelArrField] = parentObj[defaultOptions.labelArrField].concat(obj[defaultOptions.labelField])
      // 给元素添加 id数组
      obj[defaultOptions.idArrField] = parentObj[defaultOptions.idArrField].concat(obj[defaultOptions.idField])
 
      // 查找这个元素的子元素
      temp = ListToTree(data, config, obj)
      if (temp.length > 0) {
        obj[defaultOptions.childrenField] = temp
        obj[defaultOptions.leafField] = false
      } else {
        // 没有子元素 说明是叶子节点
        obj[defaultOptions.leafField] = true
      }
      tree.push(obj)
    }
  }
  return tree
}

/**
 * @description: 通过code获取树形数组方法
 * @param {*} id
 * @param {*} arr
 * @param {*} options
 * @return {*}
 * @author: syx
 */
export function GetTreeItemByCode(id, arr, options) {
  const defaultOptions = {
    idField: "id", //唯一标识字段名
    parentIdField: "parentId" //父节点唯一标识字段名
  }
  Object.assign(defaultOptions, options)
  const item = arr.find(item => item[defaultOptions.idField] === id)
  if (!item) {
    return []
  }
  return GetTreeItemByCode(item[defaultOptions.parentIdField], arr, defaultOptions).concat([item])
}

/**
 * @description: 通过label获取树形数组方法
 * @param {*} id
 * @param {*} arr
 * @param {*} options
 * @return {*}
 * @author: syx
 */
export function GetTreeItemByLabel(label, arr, options) {
  const defaultOptions = {
    idField: "id",
    labelField: "label", //唯一标识字段名
    parentIdField: "parentId" //父节点唯一标识字段名
  }
  Object.assign(defaultOptions, options)
  const item = arr.find(item => item[defaultOptions.labelField] === label)
  return GetTreeItemByCode(item[defaultOptions.idField], arr, defaultOptions)
}